import Component from '../lib/Component'
import Flickity from 'flickity'

export default class Slideshow extends Component {
    constructor (elem, APP) {
        super(elem, APP)
        this.imgSliderElem = this.elem.querySelector('.js-slideshow--img')
    }

    initSlider () {
        this.imgSlider = new Flickity(this.imgSliderElem)
        
    }

    initSliderButtons () {
        // this.nextBtn.addEventListener('click', ()=> this.slider.previous())
        // this.prevBtn.addEventListener('click', ()=> this.slider.next())
    }

    init () {
        this.initSlider()
        this.initSliderButtons()
    }
}
